import instance from "@/utils/request.js";
function getRequest(url, data) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "get",
      data,
    }).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
function postRequest(url, data) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "post",
      data,
    }).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 功能拓展
const functionList = function (data) {
  return postRequest("/website/functionExpansion/list", data);
};
// 发展历程
const developmentHistory = function () {
  return getRequest("/website/developmentHistory/queryHistory");
};
// 系统参数查询
const openConfig = function (configKey) {
  return getRequest("/system/config/configKey/data/" + configKey);
};
// 合作伙伴
const Maintenance = function (data) {
  return postRequest("/website/caseMaintenance/list", data);
};
export default {
  functionList,
  developmentHistory,
  openConfig,
  Maintenance,
};
